import * as yup from 'yup'

export const RegisterValidationSchema = yup.object().shape({
  firstName: yup.string().required("1:First Name is required"),
  lastName: yup.string().required("2:Last Name is required"),
  email: yup.string().email("3:Invalid email").required("3:Email is required"),
  password:yup.string().min(8,"4:Password must include at least 8 characters").required("4:Password is required")
});